import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment'
import { CreateCityDto, UpdateCityDto } from '../dtos/city/cityDto';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor(private http: HttpClient) { }
  
  public apiUrl = `${environment.apiUrl}/cities`;

  getList(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }


  create(entity: CreateCityDto): Observable<any> {
    return this.http.post<any>(this.apiUrl, entity);
  }

  update(id: number, entity: UpdateCityDto): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, entity);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
